var _a;
import { createActions } from 'redux-actions';
export var login = (_a = createActions('LOGIN', 'LOGIN_COMPLETE', 'LOGOUT', 'LOGOUT_COMPLETE', 'RESET_LOGIN_FORM', 'SET_AUTO_LOG_OFF'), _a.login), loginComplete = _a.loginComplete, logout = _a.logout, logoutComplete = _a.logoutComplete, resetLoginForm = _a.resetLoginForm, setAutoLogOff = _a.setAutoLogOff;
